<template>
  <div class="social-icons">
    <img src="@/assets/img/fb.png" alt="facebook-icon" />
    <img src="@/assets/img/ln.png" alt="linkedin-icon" />
    <img src="@/assets/img/tw.png" alt="twitter-icon" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.social-icons {
  margin: 30px auto;
  text-align: center;
}
.social-icons img {
  width: 30px;
  margin: 0 12px;
  cursor: pointer;
}
</style>
